var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 768",
    style: {
      enableBackground: "new 0 0 1366 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0181AE",
    d: "M366.91,702.41c12.51-45.72,24.65-90.14,36.8-134.55c2.51-9.18,7.52-18.58,6.79-27.5c-0.73-8.83-7.23-17.19-11.25-25.74 c-67.11-142.47-17.48-314.92,115.12-399.93c62.99-40.39,131.85-56.63,206.16-49c134.23,13.78,246.48,114.9,275.02,247.22 c34.6,160.45-58.11,320.75-214.96,369.72c-82.52,25.76-162.84,17.92-240.2-20.77c-3.34-1.67-8.14-2.27-11.73-1.35 c-51.5,13.2-102.9,26.75-154.34,40.21C372.23,701.26,370.12,701.68,366.91,702.41z M442.86,627.5 c31.75-8.33,62.19-16.19,92.53-24.39c5.16-1.39,9.09-0.7,13.64,2.03c58.59,35.13,121.72,46.7,188.63,33.4 c141.83-28.2,233.76-165.41,207.05-307.79c-26.53-141.43-165.28-235.9-306.97-209.01c-177.14,33.62-269.46,231.17-180.36,387.78 c9.23,16.22,11.11,29.54,5.36,46.63C454.98,579.14,449.58,602.9,442.86,627.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0181AE",
    d: "M583.83,234.68c13.47-3.34,20.03,4.74,24.72,16.88c7.17,18.58,15.01,36.91,22.89,55.2c2.74,6.37,2.5,11.98-1.63,17.46 c-6.39,8.5-12.59,17.15-19.27,25.42c-4.06,5.02-4.46,9.6-1.19,15.15c25.79,43.72,61.98,75.28,109.22,94.11 c6.47,2.58,11.58,1.41,15.91-4.01c7.75-9.69,15.69-19.24,23.36-28.99c5.76-7.32,9.37-8.9,18.3-4.9 c17.57,7.88,34.86,16.38,52.27,24.63c1.6,0.76,3.2,1.52,4.79,2.3c14.19,6.96,15.27,9.03,12.99,24.87 c-4.43,30.75-29.64,54.45-60.74,58.75c-23.74,3.28-45.52-2.62-67.56-10.13c-63.6-21.67-111.14-63.87-150.83-116.34 c-16.09-21.27-31.28-43.15-38.08-69.46c-9.04-34.94-1.67-65.71,24.02-91.74C561.44,235.34,571.51,233.18,583.83,234.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhat);
export default __webpack_public_path__ + "static/media/iconWhat.a9f8e114205ca0e64ca8b8cc35feb4b9.svg";
export { ForwardRef as ReactComponent };